import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Custom hook para limpar itens específicos do localStorage
 * quando o caminho da URL não corresponde aos padrões permitidos.
 *
 * @param {Array<Object>} pathsToKeepData - Um array de objetos que definem os padrões de caminho onde os dados devem ser mantidos.
 * Cada objeto deve ter:
 * - {string} pathPattern: O padrão do caminho (ex: "/movimentos/:id/carregamentos/validar").
 * - {number} [idSegmentIndex] (opcional): O índice do segmento do ID no caminho após o split por '/', se houver um ID no padrão.
 * @param {Array<string>} keyPrefixesToRemove - Um array de strings, que são os prefixos das chaves do localStorage a serem removidas.
 */
const useLocalStorageCleaner = (pathsToKeepData, keyPrefixesToRemove) => {
  const location = useLocation()

  useEffect(() => {
    const currentPath = location.pathname
    let shouldKeepData = false

    for (const pathConfig of pathsToKeepData) {
      const { pathPattern } = pathConfig

      // Criar Regex simples para substituir o :id
      // Isso é mais seguro que split manual por índice
      const regexPattern = new RegExp(
        '^' + pathPattern.replace(/:id/g, '[^/]+') + '$'
      )

      if (regexPattern.test(currentPath)) {
        shouldKeepData = true
        break
      }
    }

    if (!shouldKeepData) {
      // Pegar todas as chaves primeiro em um array estático
      const keys = Object.keys(localStorage)

      // Iterar sobre o array estático
      keys.forEach((key) => {
        const shouldRemove = keyPrefixesToRemove.some((prefix) =>
          key.startsWith(prefix)
        )

        if (shouldRemove) {
          localStorage.removeItem(key)
        }
      })
    }
  }, [location.pathname, pathsToKeepData, keyPrefixesToRemove])
}

export default useLocalStorageCleaner
